import React from "react";
import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import CreateNotificationForm from "./forms/CreateNotificationForm";


export default function CreateNotificationTable() {
     return (
          <>
               <MainLeftTitle title="Create Notification"></MainLeftTitle>
               <CreateNotificationForm/>
          </>
     );
}
